module.exports = __webpack_public_path__ + "img/hand-left-bottom.1caae5c7.png";